<div class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom">
    <h1 class="h1">Default Recipes</h1>
</div>

<app-menu></app-menu>

<router-outlet class="p-3"></router-outlet>
